module.exports = __webpack_public_path__ + "static/media/aji-logo.32eac5a0.32eac5a0.png";